import { render, staticRenderFns } from "./gasrecord.vue?vue&type=template&id=8a130b94&"
import script from "./gasrecord.vue?vue&type=script&lang=ts&"
export * from "./gasrecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports